<template>
  <div class="table_action">
    <div class="table_action_icon" @click="openDrap">
      <i class="el-icon-more"></i>
      <div
        class="dropdown"
        :class="name"
        v-if="dropdown_state"
        v-boxOutsideClose="closeBox"
      >
        <slot name="list"> </slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.table_action {
  z-index: 999;
  position: relative;
  .table_action_icon {
    text-align: center;
    i {
      cursor: pointer;
      &:hover {
        color: var(--mainColor);
        transform: scale(1.1);
      }
    }
  }
  .dropdown {
    position: absolute;
    padding: 2px;
    background: #fff;
    border: 1px solid #e6e6e6;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
  }
  .vendor {
    &.dropdown {
      top: -15px;
      left: 50px;
      min-width: 100px;
      text-align: center;
      position: absolute;
      z-index: 999;
      background: var(--mainColor2);
      border-radius: 5px;
      padding: 5px 0;
      color: #fff;
      box-shadow: 7px 7px 20px -10px rgba($color: #000000, $alpha: 0.5);
      div {
        line-height: 20px;
        padding: 5px 10px;
        cursor: pointer;
        border-top: 1px solid #cdbaff;
        &:hover {
          font-weight: bold;
          background: #cdbaff;
          color: #fff;
        }
        &:first-child {
          border-top: none;
        }
      }
    }
  }
}
</style>
<script>
import mixins from "@/components/mixins.js";
export default {
  name: "action_dropdown",
  mixins: [mixins],
  props: {
    name: String,
  },
  data() {
    return {
      dropdown_state: false,
    };
  },
  methods: {
    openDrap() {
      this.dropdown_state = !this.dropdown_state;
    },
    closeBox() {
      this.dropdown_state = false;
    },
  },
};
</script>
